import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-site-news="container"]',
        filter: '[js-site-news="filter"]'
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initAbout()
    }

    function initAbout() {
        $(nodeSelectors.filter).on('click', function(){
            if($(this).hasClass('closed-news')){
                $('.single-filter').removeClass('active')
                $(this).addClass('active')
                $('.single-table.active-table').css('display', 'none');
                $('.single-table.closed-table').css('display', 'block');
            }
            
            if($(this).hasClass('active-news')){
                $('.single-filter').removeClass('active')
                $(this).addClass('active')
                $('.single-table.active-table').css('display', 'block');
                $('.single-table.closed-table').css('display', 'none');
            }
        })
    }

    return Object.freeze({
        init,
    })
}